import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import CareerApplication from "@/pages/CareerApplication";

export const Route = createFileRoute("/application-career")({
  head: () => pageHead({
    title: 'Careers at Rex & Sons RVs',
    description: 'Join the Rex & Sons RVs team — apply for sales, service and parts positions at our family-owned dealership in Castle Hayne, NC.',
    path: '/application-career',
  }),
  component: CareerApplication,
});
